import { render, staticRenderFns } from "./kf.vue?vue&type=template&id=6d97256a&scoped=true&"
import script from "./kf.vue?vue&type=script&lang=js&"
export * from "./kf.vue?vue&type=script&lang=js&"
import style0 from "./kf.vue?vue&type=style&index=0&id=6d97256a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d97256a",
  null
  
)

export default component.exports